<div class="dialogContainer">
  <div class="header">
    <h2>Generate Documents</h2>
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div class="content">
    @if (documentOptions) {
      <div class="tableWrapper">
        <div class="lineSelectionOptions">
          <mat-radio-group [(ngModel)]="lineSelection">
            <mat-radio-button (change)="clearLineSelection()" value="all" class="optionValue">All Lines</mat-radio-button>
            <mat-radio-button class="optionValue" value="selected">Selected Lines</mat-radio-button>
          </mat-radio-group>
          @if (lineSelection === 'selected') {
            <button matButton="text" (click)="selectLines()">Select</button>
          }
          @if (lineSelection === 'selected') {
            <div class="selectedLineDisplay">
              {{ selectedLines() }}
            </div>
          }
        </div>
        <table class="reportTable">
          <thead>
            <tr>
              <td class="tableCell centeredCell headerCell checkboxCell" (click)="toggleAllSelections()">
                <input type="checkbox" [checked]="allItemsSelected()"/>
              </td>
              <td class="tableCell headerCell">Document Type</td>
              <td class="tableCell headerCell">Format</td>
            </tr>
          </thead>
          @for (documentOption of documentOptions; track documentOption) {
            <tr>
              @if (documentOption.documentType === 'RATING_SCHEDULE' || documentOption.documentType === 'TRANSMITTAL' || documentOption.documentType === 'UNIT_INFORMATION') {
                <td
                  class="tableCell centeredCell" (click)="updateSelection(documentOption)"
                  matTooltip="This document cannot be included in the submittal package. If checked, a separate document will be generated.">
                  <input type="checkbox" [checked]="isSelected(documentOption)"/>
                </td>
              }
              @if (documentOption.documentType !== 'RATING_SCHEDULE' && documentOption.documentType !== 'TRANSMITTAL' && documentOption.documentType !== 'UNIT_INFORMATION') {
                <td
                  class="tableCell centeredCell" (click)="updateSelection(documentOption)">
                  <input type="checkbox" [checked]="isSelected(documentOption)"/>
                </td>
              }
              @if (documentOption.documentType === 'RATING_SCHEDULE' || documentOption.documentType === 'TRANSMITTAL' || documentOption.documentType === 'UNIT_INFORMATION') {
                <td
                  matTooltip="This document cannot be included in the submittal package. If checked, a separate document will be generated."
                  class="tableCell">{{ documentOption.displayName }}
                </td>
              }
              @if (documentOption.documentType !== 'RATING_SCHEDULE' && documentOption.documentType !== 'TRANSMITTAL' && documentOption.documentType !== 'UNIT_INFORMATION') {
                <td
                  class="tableCell">{{ documentOption.displayName }}
                </td>
              }
              @if (documentOption.documentType === 'RATING_SCHEDULE' || documentOption.documentType === 'TRANSMITTAL' || documentOption.documentType === 'UNIT_INFORMATION') {
                <td
                  class="tableCell"
                  matTooltip="This document cannot be included in the submittal package. If checked, a separate document will be generated.">
                  <select class="userInput" [(ngModel)]="documentOption.documentFormat">
                    @for (format of documentOption.availableFormats; track format) {
                      <option [value]="format">{{ format }}</option>
                    }
                  </select>
                </td>
              }
              @if (documentOption.documentType !== 'RATING_SCHEDULE' && documentOption.documentType !== 'TRANSMITTAL' && documentOption.documentType !== 'UNIT_INFORMATION') {
                <td
                  class="tableCell">
                  <select class="userInput" [(ngModel)]="documentOption.documentFormat">
                    @for (format of documentOption.availableFormats; track format) {
                      <option [value]="format">{{ format }}</option>
                    }
                  </select>
                </td>
              }
            </tr>
          }
        </table>
      </div>
    }
    @if (errorMessage()) {
      <div class="errorMessage">
        {{ errorMessage() }}
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <span>
      @if (!isSchedule()) {
        <button matButton="elevated"
          matTooltip="Generates one PDF Submittal to include checked documents"
          [disabled]="isBusy() || selectedDocuments.length === 0" (click)="generateSubmittalPackage()">
          Generate submittal package
        </button>
      }
      <button matButton="elevated"
        matTooltip="Generates individual document for each checked document"
        [disabled]="isBusy() || selectedDocuments.length === 0" (click)="saveAndClose()">
        Generate
      </button>
      <button matButton="elevated" (click)="cancel()">Cancel</button>
    </span>
  </div>
</div>
